import { useEffect, useContext } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'

import { validContext } from '../lib/validContext'

import Home from './Home'
import Project from './Project'
import Answers from './Answers'
import Intents from './Intents'
import Voices from './Voices'
import ChatbotTool from './ChatbotTool'
import Report from './Report'
import Settings from './Settings'
import Page404 from './Page404'
import Footer from '../components/Footer'
import GeneralReports from './Reports/GeneralReports'
import ReportLogs from './ReportLogs'
import HomeGenAI from './GenIA/HomeGenAI' 
import ProjectGenAI from './GenIA/ProjectGenAI' 
import SettingsGenAI from './GenIA/SettingsGenAI'
import CostCenter from './CostCenter'

export default function AppRoutes() {
  let location = useLocation()
  const [isValid, setIsValid, isInValidation, setIsInValidation] =
    useContext(validContext)

  useEffect(() => {
    setIsInValidation(true)
  }, [location.pathname])

  return (
    <>
      <Routes>
        <Route path="/" element={<HomeGenAI />} />
        <Route path="/:name" element={<Project />} />
        <Route path="/:name/GenAI" element={<ProjectGenAI />} />
        <Route path="/:name/Answers" element={<Answers />} />
        <Route path="/:name/Intents" element={<Intents />} />
        <Route path="/:name/ChatbotTool" element={<ChatbotTool />} />
        <Route path="/:name/Report/:id" element={<Report />} />
        <Route path="/:name/Settings" element={<Settings />} />
        <Route path="/:name/SettingsGenAI" element={<SettingsGenAI />} />
        <Route path="/Voices" element={<Voices />} />
        <Route path="/project-reports" element={<GeneralReports />} />
        <Route path="/:name/changes-logs" element={<ReportLogs />} />
        <Route path="/excel/:name" element={<HomeGenAI />} />
        <Route path="/cost_center" element={<CostCenter />} />
        <Route path="*" element={<HomeGenAI />} />

      </Routes>
      <Footer />
    </>
  )
}
